import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';

const Breadcrumbs = ({ customItems = null }) => {
  const location = useLocation();

  const routeMapping = {
    '/': 'Home',
    '/user-registration': 'Registration',
    '/user-login': 'Login',
    '/institution-search': 'Find Programs',
    '/institution-profile': 'Institution Profile',
    '/application-form': 'Application Form',
    '/user-dashboard': 'My Applications',
  };

  const generateBreadcrumbs = () => {
    if (customItems) {
      return customItems;
    }

    const pathSegments = location?.pathname?.split('/')?.filter(Boolean);
    const breadcrumbs = [{ label: 'Home', path: '/' }];

    let currentPath = '';
    pathSegments?.forEach((segment) => {
      currentPath += `/${segment}`;
      const label = routeMapping?.[currentPath] || segment?.replace(/-/g, ' ');
      breadcrumbs?.push({
        label: label?.charAt(0)?.toUpperCase() + label?.slice(1),
        path: currentPath,
      });
    });

    return breadcrumbs;
  };

  const breadcrumbs = generateBreadcrumbs();

  if (breadcrumbs?.length <= 1) {
    return null;
  }

  return (
    <nav
      aria-label="Breadcrumb"
      className="py-4 px-6 bg-background border-b border-border"
    >
      <ol className="flex items-center gap-2 text-sm max-w-[1200px] mx-auto flex-wrap">
        {breadcrumbs?.map((crumb, index) => {
          const isLast = index === breadcrumbs?.length - 1;
          const isFirst = index === 0;

          return (
            <li key={crumb?.path} className="flex items-center gap-2">
              {!isFirst && (
                <Icon
                  name="ChevronRight"
                  size={16}
                  color="var(--color-muted-foreground)"
                />
              )}
              {isLast ? (
                <span className="text-foreground font-medium font-caption">
                  {crumb?.label}
                </span>
              ) : (
                <Link
                  to={crumb?.path}
                  className="text-muted-foreground hover:text-primary transition-smooth font-caption"
                >
                  {crumb?.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;